import { SpinResponse } from '@cgs/data-access';
import {
  AwaitableAction,
  EpicWinConfiguration,
  EpicWinPopupController,
  EpicWinPopupView,
  SoundInstance,
} from '@cgs/machines';
import {
  Action,
  Container,
  EmptyAction,
  FunctionAction,
  SequenceSimpleAction,
  SoundSceneObject,
} from '@cgs/wge';

export class CorsicaEpicWinPopupController extends EpicWinPopupController {
  private sounds: SoundInstance;
  constructor(
    container: Container,
    view: EpicWinPopupView,
    configuration: EpicWinConfiguration,
    stopBackgroundSound: boolean,
    startAfterShortWinLines: boolean
  ) {
    super(container, view, configuration, stopBackgroundSound, startAfterShortWinLines);

    const sounds = this.view.view.findById<SoundSceneObject>('commonSounds');
    if (!sounds) {
      throw new Error('Sounds not found');
    }
    this.sounds = new SoundInstance(sounds, sounds.stateMachine!);
  }

  public popupAction(response: SpinResponse): Action {
    if (!this.isBigWin(response)) {
      return new EmptyAction();
    }

    const totalWin = this.gameStateMachine.curResponse.totalWin;

    return new SequenceSimpleAction([
      new FunctionAction(() => {
        this.sounds.GoToState('stopSounds');
        this.sounds.GoToState('playSounds');
      }),
      this.view.showWinAction(this.bigWinName, totalWin),
      new AwaitableAction(this.view.show()),
    ]);
  }

  public onPopupClosed(): void {
    this.sounds.GoToState('stopSounds');
    super.onPopupClosed();
  }
}
